import { render } from "./events.vue?vue&type=template&id=1bf7b470&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import "./events.vue?vue&type=style&index=0&id=1bf7b470&scoped=true&lang=css"
import "./events.vue?vue&type=style&index=1&id=1bf7b470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf7b470"]])

export default __exports__